import { render } from "./WhatsappButtonComponent.vue?vue&type=template&id=50fb6a18&scoped=true"
import script from "./WhatsappButtonComponent.vue?vue&type=script&lang=js"
export * from "./WhatsappButtonComponent.vue?vue&type=script&lang=js"

import "./WhatsappButtonComponent.vue?vue&type=style&index=0&id=50fb6a18&scoped=true&lang=css"

import exportComponent from "/home/user/devops/sourcecode/Sopecam/sopecam-cameroontribune-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50fb6a18"]])

export default __exports__